import { i18n } from "@/boot/i18n";

export const METADATA_KIND = {
  CUSTOMER: 1,
  INTERACTION: 2
};

export const METADATA_DATA_TYPE = {
  DYNAMIC: 0,
  STATIC: 1
};

export const METADATA_TYPE = {
  TEXT: 1,
  NUMBER: 2,
  GEO: 3,
  MONEY: 4
};
export const METADATA_KIND_LABEL = {
  [METADATA_KIND.CUSTOMER]: i18n.t("consts.metadata_kind.customer"),
  [METADATA_KIND.INTERACTION]: i18n.t("consts.metadata_kind.interaction")
};

export const METADATA_TYPE_LABEL = {
  [METADATA_TYPE.TEXT]: i18n.t("consts.metadata_type.text"),
  [METADATA_TYPE.NUMBER]: i18n.t("consts.metadata_type.number"),
  [METADATA_TYPE.GEO]: i18n.t("consts.metadata_type.geo"),
  [METADATA_TYPE.MONEY]: i18n.t("consts.metadata_type.money")
};

export const METADATA_TYPE_ID_CUSTOMER = [
  { value: METADATA_TYPE.TEXT, label: i18n.t("consts.metadata_type.text") },
  { value: METADATA_TYPE.NUMBER, label: i18n.t("consts.metadata_type.number") }
];

export const METADATA_TYPE_GERAL_OPTIONS = [
  { value: METADATA_TYPE.TEXT, label: i18n.t("consts.metadata_type.text") },
  { value: METADATA_TYPE.NUMBER, label: i18n.t("consts.metadata_type.number") },
  { value: METADATA_TYPE.GEO, label: i18n.t("consts.metadata_type.geo") },
  { value: METADATA_TYPE.MONEY, label: i18n.t("consts.metadata_type.money") }
];
